function chatReducer() {
  return {};
}

export default chatReducer;
